type BusinessContactApiItem = {
  data?: {
    businessContact?: {
      key?: string;
      title?: string;
      visible?: boolean;
      cta?: Array<{
        bussinessContactSection?: {
          key?: string;
          type?: string;
          author?: string;
          status?: string;
          visible?: boolean;
          content?: Array<{
            headerSection?: {
              key?: string;
              type?: string;
              title?: string;
              author?: string;
              status?: string;
              visible?: boolean;
              description?: string;
              lists?: Array<{
                id?: number | string;
                label?: string;
                title?: string;
              }>;
            };
            breadCrumbSection?: {
              key?: string;
              type?: string;
              author?: string;
              status?: string;
              visible?: boolean;
              breadCrumbTitleNd?: string;
              breadCrumbTitleSt?: string;
            };
          }>;
        };
      }>;
    };
  };
};

export type NormalizedBusinessContact = {
  page: "businessContact";
  title: string;
  visible: boolean;

  section: {
    visible: boolean;
  };

  header: {
    title: string;
    description: string;
    visible: boolean;
    lists: Array<{
      id: string;
      label: string;
      title: string;
    }>;
  };

  breadcrumb: {
    visible: boolean;
    first: string;
    second: string;
  };

  meta: {
    key: string;
  };
};

export function normalizeBusinessContact(
  item: BusinessContactApiItem
): NormalizedBusinessContact | null {
  const businessContact = item?.data?.businessContact;
  const cta = businessContact?.cta?.[0];
  const section = cta?.bussinessContactSection;
  const content = section?.content?.[0];
  const header = content?.headerSection;
  const breadcrumb = content?.breadCrumbSection;

  if (!businessContact || !cta || !section || !content) return null;

  return {
    page: "businessContact",
    title: businessContact.title ?? "",
    visible: Boolean(businessContact.visible),

    section: {
      visible: Boolean(section.visible),
    },

    header: {
      title: header?.title ?? "",
      description: header?.description ?? "",
      visible: Boolean(header?.visible),
      lists: (header?.lists ?? []).map((entry) => ({
        id: String(entry.id ?? ""),
        label: entry.label ?? "",
        title: entry.title ?? "",
      })),
    },

    breadcrumb: {
      visible: Boolean(breadcrumb?.visible),
      first: breadcrumb?.breadCrumbTitleSt ?? "",
      second: breadcrumb?.breadCrumbTitleNd ?? "",
    },

    meta: {
      key: businessContact.key ?? "",
    },
  };
}